import React, { useEffect, useState } from 'react'
import Category from './Category'
import Header from '../../Components/Header';
import { Helmet } from 'react-helmet'
import { COUNTRY_NAME } from '../../lib';

export default function CategoryPage() {
  const [headerUpdate, setHeaderUpdate] = useState(0);
  const [title, setTitle] = useState(`KFC ${COUNTRY_NAME} | Deals & Offers`);
  const [meta, setMeta] = useState("Kentucky Fried Chicken provides the best, the most scrumptiously crispy fried chicken and zinger burgers that will leave your mouth watering for more")

  return (
    <>
      <Helmet>
        <meta name="description" content={meta} />
        <title>{title}</title>
      </Helmet>
      <div className='CategoryPage'>
        <Header headerUpdate={headerUpdate} />
        <Category setMeta={setMeta} setTitle={setTitle} setHeaderUpdate={setHeaderUpdate} headerUpdate={headerUpdate} />
      </div>
    </>
  )
}
